export default function (state, getters, rootState, rootGetters) {
    let i = 0;
    return state.items.filter(j => {
        let a = (i >= getters.row_min && i <= getters.row_max);
        i++;
        return a;
    })
}